

/** @type {import('./ref')} */
module.exports = ReferenceError;




//////////////////
// WEBPACK FOOTER
// ../node_modules/es-errors/ref.js
// module id = ../node_modules/es-errors/ref.js
// module chunks = 0